<template>
  <ul class="player-list" :class="{playerPause:!playing}">
    <li @click="playEpisode(i,$event)" :class="{active:$store.state.current === i}" v-for="(episode,i) in episodes" :key="episode.id">

      <a class="play-button" href="javascript:;" :title="checkIsPlaying(i) ? 'Play' : 'Pause'">
        <svg v-if="checkIsPlaying(i)"  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-fill play-icon" viewBox="0 0 16 16">
          <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
          <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
        </svg>
      </a>
      <a v-safe-title="episode.content" class="episode-title" href="javascript:;">{{episode.title}}</a>
      <span class="publish-time time">{{ episode.publishTime }}</span>
      <span class="time">{{ episode.duration }}</span>
      <a
        class="downloadLink"
        target="_blank"
        v-if="download && episode.downloadLink"
        :href="episode.downloadLink"
      >
        <icon-download></icon-download>
      </a>
    </li>
  </ul>
</template>

<script>
import { mapState } from "vuex";
import { MUTATION_UPDATE } from "@/store/mutations";
import IconDownload from "@/components/IconDownload";
import { sleep } from "@/common/utils";

export default {
  name: "Playlist",
  components: { IconDownload },
  computed: {
    ...mapState(["episodes","current","download","playing"]),
  },
  methods: {
    async playEpisode(i,event) {
      if (event.target.tagName.toLowerCase() === "svg"){
        return;
      }
      if (this.current === i ){
        if (this.playing){
          this.$store.commit(MUTATION_UPDATE,['stop',this.$store.state.stop+1]);
        }else{
          this.$store.commit(MUTATION_UPDATE,['start',this.$store.state.start+1]);
        }

        return;
      }
      this.$store.commit(MUTATION_UPDATE,['current',i]);
      await sleep(500);
      this.$store.commit(MUTATION_UPDATE,['start',this.$store.state.start+1]);
      this.$store.commit(MUTATION_UPDATE,["playerLoaded",false]);
      if(this.$store.state.showAppDownloadStatus===1){
        this.$store.commit(MUTATION_UPDATE, ["showAppDownloadStatus", 2]);
      }
    },
    checkIsPlaying(i) {
      return this.$store.state.current !== i || !this.playing;
    },
  }
};
</script>

<style lang="scss" scoped>
.player-list {
  width: 100%;
  padding-left: 0;
  margin-bottom: 0;
  flex-shrink: 1;
  flex-grow: 1;
  list-style: none;
  border-right: 1px solid #e4e4e4;
  border-bottom: 2px solid #e4e4e4;
  border-left: 1px solid #e4e4e4;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  -webkit-padding-start: 0;
  padding-inline-start: 0;
  overflow: auto;

  li {
    display: flex;
    align-items: center;
    padding: 6px 12px 7px 7px;
    border-bottom: 1px solid #eee;
    cursor: pointer;

    &:last-child {
      border-bottom: none;
    }

    .play-button {
      width: 20px;
    }

    .play-icon, .bi-pause-fill {
      width: 20px;
      height: 20px;
      color: #9b9b9b;
      position: relative;
      top: -1px;
    }

    .episode-title {
      flex-grow: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      padding-right: 15px;
      font-size: 13px;
      color: #1a1a1a;
      text-decoration: none;
      padding-left: 4px;
    }

    .publish-time {
      min-width: 120px;
    }

    .time {
      font-size: 12px;
      padding-right: 8px;
    }

    .downloadLink {
      flex-grow: 0;

      svg {
        color: #858585;
        width: 16px;
        height: 16px;
        position: relative;
        top: -1px;
      }
    }
  }

  background: #ffffff;

  .active {
    background: #f8f8f8;
  }

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: rgba(0, 0, 0, 0.1);
  }

  .share-dialog {
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(200, 200, 200, 0.1);
      border-radius: 0;
      background: rgba(220, 220, 220, 0.1);
    }
  }
}
@media (max-width: 425px) {
  .hasPlayList .player-list li:hover a svg{
    color: #9b9b9b !important;
  }
  .hasPlayList .player-list li:hover .episode-title{
     color: #1a1a1a !important;
  }
  .publish-time{
    display: none;
  }



}
</style>
